module.exports = __webpack_public_path__ + "components/flag/static/square/am-5bbea29815709503884f5f5ca4a060fd.svg";